<template>
  <b-skeleton
    height="31px"
    class="mb-3"
  />
</template>

<script>
export default {
  name: 'FormInput',
};
</script>

<style scoped>

</style>
